import React from "react";
import { Id } from "@planzone/dto";
import { useParams } from "react-router-dom";
import { Props } from "./types";
import { Project } from "./project";
import styles from "./styles.scss";

function ProjectsList({ projects }: Props) {
  const { projectId } = useParams<{ projectId: Id }>();

  return (
    <ul className={styles.projectsList}>
      {[...projects]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((project) => (
          <li key={project.uuid} className={styles.item}>
            <Project
              project={project as any}
              isSelected={project.uuid === projectId}
            />
          </li>
        ))}
    </ul>
  );
}

export { ProjectsList };
